import type Word from "../types/word"

const words: string[] = [
  "illustrious",
  "precious",
  "bubble",
  "dark",
  "explain",
  "melted",
  "zippy",
  "spark",
  "knee",
  "debt",
  "highfalutin",
  "bake",
  "judicious",
  "descriptive",
  "double",
  "trail",
  "fish",
  "unaccountable",
  "leather",
  "towering",
  "ajar",
  "claim",
  "material",
  "balance",
  "ashamed",
  "shoe",
  "challenge",
  "sigh",
  "rampant",
  "rake",
  "shop",
  "vengeful",
  "poised",
  "supreme",
  "mixed",
  "answer",
  "cynical",
  "pretend",
  "sweater",
  "draconian",
  "sincere",
  "grab",
  "chalk",
  "partner",
  "conscious",
  "angle",
  "squirrel",
  "unruly",
  "fragile",
  "observation",
  "unwieldy",
  "thoughtful",
  "afterthought",
  "devilish",
  "amount",
  "interest",
  "hanging",
  "unbiased",
  "sister",
  "hospital",
  "cruel",
  "selfish",
  "needle",
  "complex",
  "disagreeable",
  "land",
  "food",
  "metal",
  "pushy",
  "nosy",
  "offer",
  "truthful",
  "deafening",
  "sedate",
  "rich",
  "consider",
  "attend",
  "penitent",
  "unwritten",
  "crib",
  "pie",
  "straight",
  "search",
  "place",
  "festive",
  "minor",
  "wakeful",
  "zoom",
  "rock",
  "race",
  "floor",
  "tub",
  "lake",
  "entertain",
  "ten",
  "anxious",
  "peck",
  "time",
  "thirsty",
  "chin",
  "faded",
  "mine",
  "religion",
  "allow",
  "ice",
  "decay",
  "female",
  "determined",
  "fool",
  "truck",
  "parallel",
  "succinct",
  "belong",
  "subtract",
  "next",
  "needy",
  "incompetent",
  "maid",
  "crush",
  "bang",
  "belligerent",
  "switch",
  "sound",
  "finger",
  "full",
  "drunk",
  "rough",
  "abandoned",
  "tap",
  "summer",
  "sprout",
  "compare",
  "gruesome",
  "ticket",
  "organic",
  "miss",
  "guess",
  "corn",
  "habitual",
  "quack",
  "judge",
  "lumpy",
  "rainstorm",
  "halting",
  "confused",
  "crook",
  "invite",
  "sharp",
  "transport",
  "inform",
  "quarter",
  "bat",
  "lean",
  "soda",
  "crime",
  "tin",
  "bottle",
  "promise",
  "defective",
  "stone",
  "mouth",
  "cherry",
  "vacation",
  "gaudy",
  "knot",
  "replace",
  "insurance",
  "far",
  "drown",
  "remain",
  "defeated",
  "cry",
  "credit",
  "abortive",
  "demonic",
  "surprise",
  "smiling",
  "camp",
  "death",
  "wander",
  "hot",
  "addition",
  "crowded",
  "spell",
  "hair",
  "delirious",
  "eggs",
  "fuel",
  "unused",
  "available",
  "avoid",
  "boundary",
  "advertisement",
  "sort",
  "special",
  "detailed",
  "rabbit",
  "ugliest",
  "doll",
  "energetic",
  "flesh",
  "men",
  "filthy",
  "peace",
  "gun",
  "nappy",
  "plan",
  "adventurous",
  "smash",
  "tomatoes",
  "plucky",
  "lavish",
  "grape",
  "same",
  "glossy",
  "destroy",
  "general",
  "pine",
  "crate",
  "abundant",
  "fasten",
  "education",
  "itchy",
  "pull",
  "hands",
  "tremble",
  "bloody",
  "fang",
  "compete",
  "truculent",
  "table",
  "shivering",
  "reading",
  "kind",
  "kittens",
  "motion",
  "bushes",
  "type",
  "obedient",
  "greasy",
  "natural",
  "puzzling",
  "crack",
  "act",
  "arithmetic",
  "rabid",
  "cow",
  "goofy",
  "coast",
  "thank",
  "phobic",
  "barbarous",
  "precede",
  "bit",
  "dress",
  "complete",
  "mix",
  "dare",
  "yawn",
  "juvenile",
  "boring",
  "snatch",
  "male",
  "watery",
  "amuse",
  "bumpy",
  "one",
  "ratty",
  "reach",
  "bustling",
  "society",
  "clammy",
  "suffer",
  "receptive",
  "direction",
  "sudden",
  "admit",
  "bead",
  "current",
  "elated",
  "dance",
  "queen",
  "macabre",
  "tent",
  "complain",
  "kitty",
  "rural",
  "month",
  "wire",
  "deep",
  "flap",
  "shiny",
  "command",
  "overflow",
  "terrify",
  "luxuriant",
  "bomb",
  "tremendous",
  "interrupt",
  "half",
  "hateful",
  "fearful",
  "magnificent",
  "optimal",
  "necessary",
  "practice",
  "reflective",
  "equable",
  "jumpy",
  "pricey",
  "beam",
  "flag",
  "animal",
  "hysterical",
  "subdued",
  "aromatic",
  "peaceful",
  "measly",
  "oil",
  "zany",
  "wound",
  "plough",
  "sponge",
  "object",
  "rude",
  "mint",
  "man",
  "pass",
  "stomach",
  "ripe",
  "mitten",
  "hover",
  "bare",
  "snake",
  "verse",
  "enchanted",
  "sassy",
  "delay",
  "arrest",
  "private",
  "please",
  "stick",
  "easy",
  "shelter",
  "tire",
  "unsightly",
  "deserted",
  "aberrant",
  "supply",
  "savory",
  "comparison",
  "tacit",
  "clumsy",
  "mammoth",
  "harmonious",
  "destruction",
  "achiever",
  "branch",
  "heat",
  "passenger",
  "camera",
  "tender",
  "home",
  "gamy",
  "creature",
  "unique",
  "moon",
  "hug",
  "mushy",
  "nebulous",
  "rat",
  "humorous",
  "work",
  "omniscient",
  "irate",
  "snore",
  "telephone",
  "bawdy",
  "flame",
  "writer",
  "beds",
  "tow",
  "reject",
  "press",
  "super",
  "whole",
  "cap",
  "obese",
  "present",
  "wrathful",
  "five",
  "entertaining",
  "rejoice",
  "adorable",
  "bath",
  "occur",
  "multiply",
  "coal",
  "hulking",
  "panicky",
  "worried",
  "elastic",
  "approval",
  "perpetual",
  "eight",
  "dear",
  "piquant",
  "voiceless",
  "control",
  "foolish",
  "uttermost",
  "squeal",
  "chew",
  "exuberant",
  "jam",
  "soup",
  "productive",
  "right",
  "skinny",
  "quill",
  "jolly",
  "lumber",
  "bore",
  "excellent",
  "laugh",
  "snobbish",
  "push",
  "ship",
  "spotty",
  "third",
  "wriggle",
  "boorish",
  "oval",
  "harsh",
  "hand",
  "part",
  "cannon",
  "tramp",
  "cake",
  "jewel",
  "regret",
  "mundane",
  "whip",
  "elbow",
  "babies",
  "living",
  "volatile",
  "health",
  "dangerous",
  "lackadaisical",
  "treat",
  "educated",
  "clam",
  "cowardly",
  "drip",
  "wax",
  "paste",
  "sick",
  "laughable",
  "turn",
  "yielding",
  "icy",
  "rice",
  "clap",
  "frightened",
  "self",
  "bouncy",
  "vein",
  "behavior",
  "disgusted",
  "automatic",
  "slip",
  "bounce",
  "kindhearted",
  "signal",
  "calculate",
  "trucks",
  "close",
  "tart",
  "premium",
  "miscreant",
  "vagabond",
  "dusty",
  "pathetic",
  "road",
  "sore",
  "wren",
  "help",
  "dog",
  "bike",
  "bone",
  "heady",
  "dogs",
  "earsplitting",
  "womanly",
  "protect",
  "hook",
  "merciful",
  "queue",
  "ball"
]

const stringsToWords = (words: string[]): Word[] => words.map((word: string) => ({ text: word }))

export default stringsToWords(words)

export { stringsToWords }

